import { render, staticRenderFns } from "./CreateAccount.vue?vue&type=template&id=38a6bdce&scoped=true&"
import script from "./CreateAccount.vue?vue&type=script&lang=js&"
export * from "./CreateAccount.vue?vue&type=script&lang=js&"
import style0 from "./CreateAccount.vue?vue&type=style&index=0&id=38a6bdce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a6bdce",
  null
  
)

export default component.exports